<template>
  <div class="home">
    <div class="container">
      <Header />
      <div class="row bg_ffffff">
        <div class="col-12 col-sm-12 padding_30 padding_top_0">
          <div class="csfont_Signika_Lite color_6d6e71 text-left font-size-16">
            <form @submit.prevent="Submit">
              <div class="row px-3">
                <!-- 1 row -->
                <div class="col-12 col-sm-12 p-0 px-3" style="margin-top: 10px">
                  <h4 class="text-dark">Organisation</h4>
                  <input
                    type="text"
                    class="w-100 mt-1"
                    v-model="Organisation"
                    required
                  />
                </div>
                <!-- End row -->
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                  <h4 class="text-dark">Local Office</h4>
                </div>
                <!-- 1 row -->
                <div class="col-12 col-sm-12 px-3">
                  <b>Address:</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Local.Address"
                    required
                  />
                </div>
                <!-- End row -->
                <!-- 1 row -->
                <div class="col-12 col-sm-6" style="margin-top: 10px">
                  <b>Region: </b>
                  <select
                    class="w-100"
                    v-model="LocalSelectProvince"
                    @change="setProvinceDataLocal()"
                    required
                    style="padding: 2px"
                  >
                    <option selected disabled value="null">
                      ---- Please Select Province ----
                    </option>
                    <option
                      v-for="(item, key) in Province"
                      :key="key"
                      :value="item.id"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </div>
                <div class="col-12 col-sm-6" style="margin-top: 10px">
                  <b>Province: </b>
                  <select
                    class="w-100"
                    v-model="LocalSelectCity"
                    required
                    style="padding: 2px"
                  >
                    <option selected disabled value="null">
                      ---- Please Select City ----
                    </option>
                    <option
                      v-for="(item, key) in LocalCity"
                      :key="key"
                      :value="item.value"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </div>
                <!-- End row -->
                <!-- 1 row -->
                <div class="col-12 col-sm-6" style="margin-top: 10px">
                  <b>Direct Number : </b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Local.Tel"
                    required
                    placeholder="+xx (0) x xxx xxxx "
                  />
                </div>
                <div class="col-12 col-sm-6" style="margin-top: 10px">
                  <b>Mobile Number (Optional) :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Local.Fax"
                    placeholder="+xx (0) x xxx xxxx "
                  />
                </div>
                <!-- End row -->
                <!-- 1 row -->
                <div
                  class="col-12 col-sm-6 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Email : </b>
                  <input
                    type="email"
                    class="w-100"
                    v-model="Email"
                    required
                    placeholder="example@mail.com"
                  />
                </div>
                <div class="col-12 col-sm-6 my-2 px-3" style="margin-top: 10px">
                  <b>Website :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Website"
                    required
                    placeholder="www.example.com"
                  />
                </div>
                <!-- End row -->
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                  <h4 class="text-dark">
                    Bangkok Office
                    <small class="pl-3">
                      <input
                        type="checkbox"
                        v-model="BangkokAddSame"
                        @click="BangkokAddressStatus"
                        :checked="BangkokAddSame == true"
                        value="0"
                        selected
                        style="vertical-align: top"
                      />
                      <label class="pl-1 pr-3">Same as above</label>
                      <input
                        type="checkbox"
                        v-model="BangkokAddNone"
                        @click="BangkokAddressStatus"
                        :checked="BangkokAddNone == true"
                        value="1"
                        style="vertical-align: top"
                      />
                      <label class="pl-1 pr-3">None</label>
                    </small>
                  </h4>
                </div>
                <!-- 1 row -->
                <div class="col-12 col-sm-12 px-3">
                  <b>Address :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Bangkok.Address"
                    :disabled="
                      BangkokDisable == true ||
                      BangkokAddSame == true ||
                      BangkokAddNone == true
                    "
                  />
                </div>
                <!-- End row -->

                <!-- 1 row -->
                <div
                  class="col-12 col-sm-6 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Direct Number : </b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Bangkok.Tel"
                    placeholder="+xx (0) x xxx xxxx "
                    :disabled="
                      BangkokDisable == true ||
                      BangkokAddSame == true ||
                      BangkokAddNone == true
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 my-2 px-3" style="margin-top: 10px">
                  <b>Mobile Number (Optional) :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Bangkok.Fax"
                    placeholder="+xx (0) x xxx xxxx"
                    :disabled="
                      BangkokDisable == true ||
                      BangkokAddSame == true ||
                      BangkokAddNone == true
                    "
                  />
                </div>
                <!-- End row -->
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                  <h4 class="text-dark">Authorised By</h4>
                </div>
                <!-- 1 row -->
                <div class="col-12 col-sm-6 p-0 my-2 px-3">
                  <b>Name :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Represented.Name"
                    required
                  />
                </div>
                <div class="col-12 col-sm-6 my-2 px-3">
                  <b>Title :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Represented.Title"
                    required
                  />
                </div>
                <!-- End row -->
                <!-- 1 row -->
                <div
                  class="col-12 col-sm-4 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Direct Number : </b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Represented.Tel"
                    required
                    placeholder="+xx (0) x xxx xxxx "
                  />
                </div>
                <div class="col-12 col-sm-4 my-2 px-3" style="margin-top: 10px">
                  <b>Mobile Number (Optional) :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Represented.Fax"
                    placeholder="+xx (0) x xxx xxxx "
                  />
                </div>
                <div class="col-12 col-sm-4 my-2 px-3" style="margin-top: 10px">
                  <b>Email :</b>
                  <input
                    type="email"
                    class="w-100"
                    v-model="Represented.Email"
                    required
                    placeholder="example@mail.com"
                  />
                </div>
                <!-- End row -->
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                  <h4 class="text-dark">Contact Person</h4>
                </div>
                <!-- 1 row -->
                <div class="col-12 col-sm-6 p-0 my-2 px-3">
                  <b>Name : </b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Alternate.Name"
                    required
                  />
                </div>
                <div class="col-12 col-sm-6 my-2 px-3">
                  <b>Title :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Alternate.Title"
                    required
                  />
                </div>
                <!-- End row -->
                <!-- 1 row -->
                <div
                  class="col-12 col-sm-4 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Direct Number : </b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Alternate.Tel"
                    required
                    placeholder="+xx (0) x xxx xxxx "
                  />
                </div>
                <div class="col-12 col-sm-4 my-2 px-3" style="margin-top: 10px">
                  <b>Mobile Number (Optional) :</b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="Alternate.Fax"
                    placeholder="+xx (0) x xxx xxxx "
                  />
                </div>
                <div class="col-12 col-sm-4 my-2 px-3" style="margin-top: 10px">
                  <b>Email :</b>
                  <input
                    type="email"
                    class="w-100"
                    v-model="Alternate.Email"
                    required
                    placeholder="example@mail.com"
                  />
                </div>
                <!-- End row -->
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                </div>
                <!-- 1 row -->
                <div
                  class="col-12 col-sm-12 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Description of Services (30 words) : </b>
                  <textarea
                    rows="4"
                    class="w-100"
                    v-model="DescriptionServices"
                    required
                  ></textarea>
                </div>
                <!-- End row -->
                <!-- 1 row -->
                <div
                  class="col-12 col-sm-12 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Experience in MICE Industry (50 words) : </b>
                  <textarea
                    rows="4"
                    class="w-100"
                    v-model="ExperienceMICE"
                    required
                  >
                  </textarea>
                </div>

                <!-- End row -->
                <!-- 1 row -->
                <div
                  class="col-12 col-sm-12 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Membership of Other Association(s) : </b>
                  <multiselect
                    v-model="OAMembership"
                    tag-placeholder="Add this as new tag"
                    placeholder="Selected Membership of Other Association"
                    label="name"
                    track-by="code"
                    :options="options"
                    :multiple="true"
                    :taggable="true"
                  ></multiselect>
                </div>
                <div
                  :class="{ 'd-none': displayOptionsOther }"
                  class="col-12 col-sm-12 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <input
                    type="text"
                    class="w-45"
                    v-model="OptionsOther"
                    placeholder="Other..."
                  />
                  <label
                    class="custom-file-upload btn btn-app ml-2 px-5 other-btn"
                    @click="findOtherData"
                  >
                    add
                  </label>
                </div>
                <!-- End row -->
                <!-- 1 row -->
                <div class="col-12 col-sm-12" style="margin-top: 20px">
                  <b class="text-dark">Documents:</b>
                </div>
                <!-- 1 row -->
                <div
                  class="col-12 col-sm-12"
                  style="margin-top: 10px; margin-left: 30px"
                >
                  <b>
                    <div class="row">
                      <div class="col-sm-8 py-1 text-dark">
                        <span>
                          1. Letters of Recommendation from 2 TICA Members
                        </span>
                        <span class="text-danger"> *</span>
                      </div>
                      <div class="col-sm-4 py-1">
                        <div class="row">
                          <label
                            for="uploadLORF2TM"
                            class="
                              col-4 col-sm-4
                              custom-file-upload
                              btn btn-app
                            "
                          >
                            Upload
                          </label>
                          <div class="col-8 col-sm-8 text-truncate">
                            {{ LORF2TMDocumentsCount }}
                          </div>
                          <input
                            id="uploadLORF2TM"
                            type="file"
                            @change="uploadLORF2TM"
                          />
                        </div>
                      </div>
                      <div class="col-sm-8 py-1 text-dark"></div>
                      <div class="col-sm-4 py-1">
                        <div class="row">
                          <label
                            for="uploadLORF2TM2"
                            class="
                              col-4 col-sm-4
                              custom-file-upload
                              btn btn-app
                            "
                          >
                            Upload
                          </label>
                          <div class="col-8 col-sm-8 text-truncate">
                            {{ LORF2TM2DocumentsCount }}
                          </div>
                          <input
                            id="uploadLORF2TM2"
                            type="file"
                            @change="uploadLORF2TM2"
                          />
                        </div>
                      </div>
                      <div class="col-sm-8 py-1 text-dark">
                        <span> 2. Copy of Business Registration </span>
                        <span class="text-danger"> *</span>
                      </div>
                      <div class="col-sm-4 py-1">
                        <div class="row">
                          <label
                            for="uploadCOBR"
                            class="
                              col-4 col-sm-4
                              custom-file-upload
                              btn btn-app
                            "
                          >
                            Upload
                          </label>
                          <span class="col-8 col-sm-8 text-truncate">
                            {{ COBRDocumentsCount }}
                          </span>
                          <input
                            id="uploadCOBR"
                            type="file"
                            @change="uploadCOBR"
                          />
                        </div>
                      </div>
                      <div class="col-sm-8 py-1 text-dark">
                        <span> 3. Copy of Business License(s) </span>
                      </div>
                      <div class="col-sm-4 py-1">
                        <div class="row">
                          <label
                            for="uploadCOBL"
                            class="
                              col-4 col-sm-4
                              custom-file-upload
                              btn btn-app
                            "
                          >
                            Upload
                          </label>
                          <span class="col-8 col-sm-8 text-truncate">
                            {{ COBLDocumentsCount }}
                          </span>
                          <input
                            id="uploadCOBL"
                            type="file"
                            @change="uploadCOBL"
                          />
                        </div>
                      </div>
                      <div class="col-sm-8 py-1 text-dark">
                        <span> 4. Copy of Por Por .20 </span>
                        <span class="text-danger"> *</span>
                      </div>
                      <div class="col-sm-4 py-1">
                        <div class="row">
                          <label
                            for="uploadCOPP"
                            class="
                              col-4 col-sm-4
                              custom-file-upload
                              btn btn-app
                            "
                          >
                            Upload
                          </label>
                          <span class="col-8 col-sm-8 text-truncate">
                            {{ COPPDocumentsCount }}
                          </span>
                          <input
                            id="uploadCOPP"
                            type="file"
                            @change="uploadCOPP"
                          />
                        </div>
                      </div>
                    </div>
                  </b>
                </div>
                <!-- End row -->
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                </div>
                <div class="col-12 col-sm-12">
                  <fieldset :disabled="disabledNotHotel == 1">
                    <div class="row">
                      <!-- 1 row -->
                      <div class="col-12 col-sm-6 p-0 my-2 px-3">
                        <b>Membership Category: </b>
                        <select
                          class="custom-select w-100"
                          v-model="MembershipCategoryNumber"
                          @change="notHotelChange()"
                          required
                          style="padding: 3px"
                        >
                          <option selected disabled value="null">
                            ---- Select Category ----
                          </option>
                          <option
                            v-for="(item, key) in MembershipCategoryData"
                            :key="key"
                            :value="key"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-12 col-sm-6 p-0 my-2 px-3">
                        <b>Subscription Rate THB : </b>
                        <input
                          type="number"
                          class="w-100"
                          v-model="SubscriptionRate"
                          @change="notHotelChange()"
                          readonly
                          required
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-12 col-sm-12" style="margin-top: 10px">
                  <hr class="text-secondary" />
                  <h4 class="text-dark" style="margin-top: 20px">
                    For Hotel Only
                  </h4>
                </div>
                <div class="col-12 col-sm-12">
                  <fieldset :disabled="disabledHotel == 1">
                    <div class="row">
                      <div class="col-12 col-sm-6 p-0 my-2 px-3">
                        <b>Number of Rooms :</b>
                        <input
                          type="number"
                          class="w-100"
                          v-model="ForHotelOnly.NumberOfRooms"
                          @change="hotelChange()"
                          required
                        />
                      </div>
                      <div
                        class="col-12 col-sm-12 p-0 my-2 px-3"
                        style="margin-top: 10px"
                      >
                        <span id="CategoryList">
                          (Please select your category)
                        </span>
                      </div>
                      <!-- category list A-->
                      <div
                        class="col-12 col-sm-12 my-2 text-left"
                        style="margin-top: 20px"
                      >
                        <div class="row">
                          <div class="col-12 col-sm-2 p-0 my-2 text-left">
                            <input
                              type="checkbox"
                              id="CategoryA"
                              value="0"
                              v-model="ForHotelOnly.Category"
                              @click="disabledCatA = (disabledCatA + 1) % 2"
                              :disabled="disabledCheckbok[0] == 1"
                              @change="hotelChange()"
                            />
                            <label for="CategoryA" class="pl-2">
                              Category A:
                            </label>
                          </div>
                          <div class="col-12 col-sm-6 p-0 my-2">
                            <div class="pl-1">
                              <b>Hotel</b> with meeting facilities of
                              <u>over</u> 600 capacities (theatre style)<br />
                              THB 60 per 1 guest room
                            </div>
                          </div>
                          <div class="col-4 col-sm-4 p-0 my-2">
                            <div class="pl-2">
                              <br />
                              Total = THB
                              <input
                                type="number"
                                style="width: 80px"
                                :disabled="disabledCatA == 0"
                                v-model="TotalBahtA"
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--End category list A-->

                      <!-- category list B-->
                      <div
                        class="col-12 col-sm-12 my-2 text-left"
                        style="margin-top: 20px"
                      >
                        <div class="row">
                          <div class="col-12 col-sm-2 p-0 my-2 text-left">
                            <input
                              type="checkbox"
                              id="CategoryB"
                              value="1"
                              v-model="ForHotelOnly.Category"
                              @click="disabledCatB = (disabledCatB + 1) % 2"
                              :disabled="disabledCheckbok[1] == 1"
                              @change="hotelChange()"
                            />
                            <label for="CategoryB" class="pl-2">
                              Category B:
                            </label>
                          </div>
                          <div class="col-12 col-sm-6 p-0 my-2">
                            <div class="pl-1">
                              <b>Hotel</b> with meeting facilities of
                              <u>less than</u> 600 capacities (theatre style)<br />
                              THB 36 per 1 guest room
                            </div>
                          </div>
                          <div class="col-4 col-sm-4 p-0 my-2">
                            <div class="pl-2">
                              <br />
                              Total = THB
                              <input
                                type="number"
                                style="width: 80px"
                                :disabled="disabledCatB == 0"
                                v-model="TotalBahtB"
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--End category list B-->

                      <!-- category list C-->
                      <div
                        class="col-12 col-sm-12 my-2 text-left"
                        style="margin-top: 20px"
                      >
                        <div class="row">
                          <div class="col-12 col-sm-2 p-0 my-2 text-left">
                            <input
                              type="checkbox"
                              id="CategoryC"
                              value="2"
                              v-model="ForHotelOnly.Category"
                              @click="disabledCatC = (disabledCatC + 1) % 2"
                              :disabled="disabledCheckbok[2] == 1"
                              @change="hotelChange()"
                            />
                            <label for="CategoryC" class="pl-2">
                              Category C:
                            </label>
                          </div>
                          <div class="col-12 col-sm-6 p-0 my-2">
                            <div class="pl-1">
                              <b>Hotel</b> <u>without</u> meeting facilities
                              <br />
                              THB 12 per 1 guest room
                            </div>
                          </div>
                          <div class="col-4 col-sm-4 p-0 my-2">
                            <div class="pl-2">
                              <br />
                              Total = THB
                              <input
                                type="number"
                                style="width: 80px"
                                :disabled="disabledCatC == 0"
                                v-model="TotalBahtC"
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--End category list C-->

                      <!-- category list D-->
                      <div
                        class="col-12 col-sm-12 my-2 text-left"
                        style="margin-top: 20px"
                      >
                        <div class="row">
                          <div class="col-12 col-sm-2 p-0 my-2 text-left">
                            <input
                              type="checkbox"
                              id="CategoryD"
                              value="3"
                              v-model="ForHotelOnly.Category"
                              @click="disabledCatD = (disabledCatD + 1) % 2"
                              :disabled="disabledCheckbok[3] == 1"
                              @change="hotelChange()"
                            />
                            <label for="CategoryD" class="pl-2">
                              Category D:
                            </label>
                          </div>
                          <div class="col-12 col-sm-6 p-0 my-2">
                            <div class="pl-2">
                              <b>Up-Country Hotels</b> with meeting facilities
                              of <u>over</u> 600 capacities (Theatre style)
                              <br />
                              THB 30 per 1 guest room
                            </div>
                          </div>
                          <div class="col-4 col-sm-4 p-0 my-2">
                            <div class="pl-2">
                              <br />
                              Total = THB
                              <input
                                type="number"
                                style="width: 80px"
                                :disabled="disabledCatD == 0"
                                v-model="TotalBahtD"
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--End category list D-->

                      <!-- category list E-->
                      <div
                        class="col-12 col-sm-12 my-2 text-left"
                        style="margin-top: 20px"
                      >
                        <div class="row">
                          <div class="col-12 col-sm-2 p-0 my-2 text-left">
                            <input
                              type="checkbox"
                              id="CategoryE"
                              value="4"
                              v-model="ForHotelOnly.Category"
                              @click="disabledCatE = (disabledCatE + 1) % 2"
                              :disabled="disabledCheckbok[4] == 1"
                              @change="hotelChange()"
                            />
                            <label for="CategoryE" class="pl-2 disable">
                              Category E:
                            </label>
                          </div>
                          <div class="col-12 col-sm-6 p-0 my-2">
                            <div class="pl-2">
                              <span>
                                <b>Up-Country Hotels</b> with meeting facilities
                                of <u>less than</u> 600 Capacity (Theatre style)
                                <br />
                                THB 18 per 1 guest room
                              </span>
                            </div>
                          </div>
                          <div class="col-4 col-sm-4 p-0 my-2">
                            <div class="pl-2">
                              <br />
                              Total = THB
                              <input
                                type="number"
                                style="width: 80px"
                                :disabled="disabledCatE == 0"
                                v-model="TotalBahtE"
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--End category list E-->
                    </div>
                  </fieldset>
                </div>
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                  <div class="tesxt-dark px-3">
                    <b style="float: left; padding-left: 280px"
                      >Joining Fee Rate</b
                    >
                    <b style="float: right; padding-right: 38px"
                      ><span class="px-2">THB {{ JoiningFeeRate }}</span>
                    </b>
                  </div>
                  <br />
                  <div class="tesxt-dark px-3">
                    <div style="float: left; padding-left: 280px">
                      <b>Grand Total </b>
                      <small>(excluding VAT 7%)</small>
                    </div>
                    <b style="float: right; padding-right: 38px"
                      ><span class="px-2">THB {{ GrandTotal }}</span>
                    </b>
                  </div>
                  <br />
                </div>
                <div class="col-12 col-sm-12">
                  <hr class="text-secondary" />
                </div>
                <div class="col-12 col-sm-6 p-0 my-2 px-3">
                  <b>Authorised Signature : </b>
                  <br />
                  <div class="row">
                    <label
                      for="AuthorisedSignatureUpload"
                      class="col-5 col-md-5 custom-file-upload btn btn-app ml-3"
                    >
                      Upload Signature
                    </label>
                    <div class="col-6 col-md-6 text-truncate">
                      {{ AuthorisedSignatureCount }}
                    </div>
                    <input
                      id="AuthorisedSignatureUpload"
                      type="file"
                      @change="setFileSignature"
                      accept="image/*"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6 p-0 my-2 px-3">
                  <b>Name in Capital Letters : </b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="CapitalLetters.Name"
                    required
                  />
                </div>
                <div
                  class="col-12 col-sm-6 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Title : </b>
                  <input
                    type="text"
                    class="w-100"
                    v-model="CapitalLetters.Title"
                    required
                  />
                </div>
                <div
                  class="col-12 col-sm-6 p-0 my-2 px-3"
                  style="margin-top: 10px"
                >
                  <b>Date :</b>
                  <br />
                  <input
                    type="date"
                    class="w-100"
                    v-model="CapitalLetters.Date"
                    required
                    readonly
                  />
                </div>
                <div
                  class="col-12 col-sm-12 p-0 my-2 px-3"
                  style="margin-top: 5rem"
                >
                  <b>
                    If you have any questions, please contact us at
                    <a href="mailto: info@tica.or.th">info@tica.or.th</a>,
                    <a href="mailto: office@tica.or.th">office@tica.or.th</a>, or
                    tel +662 938 6590-3.
                  </b>
                </div>
              </div>
              <center>
                <button type="submit" class="btn btn-app mt-5 align-center">
                  <div v-if="!display">Review</div>
                  <div class="loader" v-if="display">Loading...</div>
                </button>
              </center>
              <br />
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// CSS
import "@/assets/maincss/bootstrap.min.css";
import "@/assets/maincss/animate.css";
import "@/assets/maincss/fontface.css";
import "@/assets/css/font.css";
import "@/assets/maincss/custom.css";
import "@/assets/css/spacing.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

// Component
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Multiselect,
  },
  data() {
    return {
      options: [
        { name: "Association of Thai Trave Agents (ATTA)", code: "1" },
        {
          name: "Business Of Creative And Event Management Association (EMA)",
          code: "2",
        },
        { name: "Thai Hotels Association (THA)", code: "3" },
        { name: "Thai Exhibition Association (TEA)", code: "4" },
        { name: "Thailand Management Association (TMA)", code: "5" },
        { name: "Thailand Travel Agents Association (TTAA)", code: "6" },
        { name: "The Association of Domestic Travel (ADT)", code: "7" },
        { name: "The Association of Thai Tour Operators (ATTO)", code: "8" },
        { name: "Tourism Council of Thailand (TCT)", code: "9" },
        { name: "Other", code: "10" },
      ],
      OptionsOther: null,
      displayOptionsOther: true,
      // Toggle btn
      disabledCatA: 0,
      disabledCatB: 0,
      disabledCatC: 0,
      disabledCatD: 0,
      disabledCatE: 0,
      disabledCheckbok: [0, 0, 0, 0, 0],
      disabledHotel: 0,
      disabledNotHotel: 0,
      TotalBahtA: null,
      TotalBahtB: null,
      TotalBahtC: null,
      TotalBahtD: null,
      TotalBahtE: null,
      // End toggle btn
      Organisation: null,
      Local: {
        Address: null,
        Tel: null,
        Fax: null,
      },
      Bangkok: {
        Address: null,
        Tel: null,
        Fax: null,
      },
      Email: null,
      Website: null,
      Represented: {
        Name: null,
        Title: null,
        Tel: null,
        Fax: null,
        Email: null,
      },
      Alternate: {
        Name: null,
        Title: null,
        Tel: null,
        Fax: null,
        Email: null,
      },
      DescriptionServices: null,
      DescriptionServicesMax: null,
      ExperienceMICE: null,
      ExperienceMICEMax: null,
      OAMembership: [],
      MembershipCategoryData: [
        { name: "Hotels", price: 0 },
        { name: "DMC - Destination Management Company", price: 12000 },
        {
          name: "DMC - Up-Country DMC (Operate Multiple Destination)",
          price: 12000,
        },
        {
          name: "DMC - Up-Country DMC (Operate Single Destination)",
          price: 6000,
        },
        { name: "Surface Transport Operators", price: 6000 },
        { name: "PCO - Professional Conference Organiser", price: 12000 },
        { name: "PEO - Professional Exhibition Organiser", price: 12000 },
        { name: "EMC - Event Management Company", price: 12000 },
        { name: "Stand Contractor", price: 12000 },
        { name: "Freight Forwarder", price: 12000 },
        { name: "Media House", price: 6000 },
        { name: "Convention Center", price: 25000 },
        { name: "Exhibition Center", price: 2500 },
        { name: "Local Attraction", price: 12000 },
        { name: "Thai Airways International", price: 700000 },
        { name: "Associate Airlines", price: 6000 },
        { name: "F&B Suppliers", price: 12000 },
        { name: "Shops & Restaurants", price: 6000 },
        { name: "Monetary Agencies", price: 0 },
        { name: "Tourism Educational Institute", price: 6000 },
        { name: "Associate Membership", price: 6000 },
        { name: "Communications Company", price: 6000 },
        { name: "Document Service", price: 0 },
        { name: "Affiliate Organisations", price: 0 },
        { name: "National Tourism Organisation", price: 0 },
      ],
      MembershipCategoryNumber: null,
      MembershipCategory: null,
      SubscriptionRate: null,
      ForHotelOnly: {
        NumberOfRooms: null,
        Category: [],
        TotalBaht: null,
      },
      GrandTotal: null,
      JoiningFeeRate: 1500,
      AuthorisedSignature: null,
      AuthorisedSignatureURL: null,
      CapitalLetters: {
        Name: null,
        Title: null,
        Date: new Date().toISOString().slice(0, 10),
      },
      MultipleUploadFile: [],
      MultipleUploadFileURL: [],
      MultipleUploadFileType: [],
      RequiredDocumentsCount: null,
      AuthorisedSignatureCount: null,
      LORF2TMDocuments: null,
      LORF2TM2Documents: null,
      COBRDocuments: null,
      COBLDocuments: null,
      COPPDocuments: null,
      LORF2TMDocumentsCount: null,
      LORF2TM2DocumentsCount: null,
      COBRDocumentsCount: null,
      COBLDocumentsCount: null,
      COPPDocumentsCount: null,
      display: false,
      Province: [
        {
          id: 1,
          value: "Central",
          city: [
            { value: "Kanchanaburi" },
            { value: "Nakhonpathom" },
            { value: "Nonthaburi" },
            { value: "Pathumthani" },
            { value: "Phetchaburi" },
            { value: "Prachuap Khiri Khan" },
            { value: "Samutprakarn" },
          ],
        },
        {
          id: 2,
          value: "East",
          city: [
            { value: "Chanthaburi" },
            { value: "Chonburi" },
            { value: "Trat" },
            { value: "Prachinburi" },
            { value: "Rayong" },
          ],
        },
        {
          id: 3,
          value: "North",
          city: [{ value: "Chiang-Mai" }, { value: "Chiang-Rai" }],
        },
        {
          id: 4,
          value: "North-East",
          city: [
            { value: "Khon-Kaen" },
            { value: "Nakhon-Ratchasima" },
            { value: "Ubon-Ratchathani" },
            { value: "Udon-Thani" },
          ],
        },
        {
          id: 5,
          value: "South",
          city: [
            { value: "Krabi" },
            { value: "Phang-Nga" },
            { value: "Phuket" },
            { value: "Samui" },
            { value: "Songkhla" },
            { value: "Suratthani" },
            { value: "Trang" },
          ],
        },
        {
          id: 6,
          value: "Bangkok",
          city: [{ value: "Bangkok" }],
        },
      ],
      LocalCity: null,
      BangkokCity: null,
      LocalSelectProvince: null,
      LocalSelectCity: null,
      BangkokSelectData: null,
      BangkokAddSame: false,
      BangkokAddNone: false,
      BangkokDisable: false,
    };
  },
  beforeUpdate() {
    // Category Disable
    if (this.ForHotelOnly.Category.length > 0) {
      this.disabledCheckbok = [1, 1, 1, 1, 1];
      this.disabledCheckbok[this.ForHotelOnly.Category[0]] = 0;
    } else {
      this.disabledCheckbok = [0, 0, 0, 0, 0];
      this.GrandTotal = this.JoiningFeeRate + this.SubscriptionRate;
    }

    // Total Baht Disable
    if (this.disabledCatA === 0) {
      this.TotalBahtA = null;
    } else if (this.disabledCatA == 1) {
      this.TotalBahtA = this.ForHotelOnly.NumberOfRooms * 60;
      this.GrandTotal = this.TotalBahtA + this.JoiningFeeRate;
    }
    //
    if (this.disabledCatB === 0) {
      this.TotalBahtB = null;
    } else if (this.disabledCatB == 1) {
      this.TotalBahtB = this.ForHotelOnly.NumberOfRooms * 36;
      this.GrandTotal = this.TotalBahtB + this.JoiningFeeRate;
    }
    //
    if (this.disabledCatC === 0) {
      this.TotalBahtC = null;
    } else if (this.disabledCatC == 1) {
      this.TotalBahtC = this.ForHotelOnly.NumberOfRooms * 12;
      this.GrandTotal = this.TotalBahtC + this.JoiningFeeRate;
    }
    //
    if (this.disabledCatD === 0) {
      this.TotalBahtD = null;
    } else if (this.disabledCatD == 1) {
      this.TotalBahtD = this.ForHotelOnly.NumberOfRooms * 30;
      this.GrandTotal = this.TotalBahtD + this.JoiningFeeRate;
    }
    //
    if (this.disabledCatE === 0) {
      this.TotalBahtE = null;
    } else if (this.disabledCatE == 1) {
      this.TotalBahtE = this.ForHotelOnly.NumberOfRooms * 18;
      this.GrandTotal = this.TotalBahtE + this.JoiningFeeRate;
    }
    //
    if (this.DescriptionServices != null) {
      this.checkWordDes(this.DescriptionServices, 30);
    }
    if (this.ExperienceMICE != null) {
      this.checkWordEx(this.ExperienceMICE, 50);
    }
    const data = this.OAMembership;
    const indexArray = this.OAMembership.length - 1;
    const result = data.find(({ name }) => name === "Other");
    if (result == undefined) {
      return 1;
    } else if (result.name !== undefined && result.name === "Other") {
      this.OAMembership.splice(indexArray, 1);
      this.displayOptionsOther = false;
    }
  },
  mounted() {
    this.GrandTotal = this.JoiningFeeRate;
    this.setData();
  },
  methods: {
    setData() {
      let data = JSON.parse(sessionStorage.getItem("membershipApplication"));
      console.log(data);
      this.Organisation = data.Organisation;
      // local address
      this.Local.Address = data.LocalAddress;
      this.LocalSelectProvince = data.LocalProvince;
      this.LocalCity = this.Province[this.LocalSelectProvince - 1].city;
      this.LocalSelectCity = data.LocalCity;
      this.Local.Tel = data.LocalDirectNumber;
      this.Local.Fax = data.LocalMobile;
      this.Email = data.LocalEmail;
      this.Website = data.LocalWebsite;
      // Bangkok address
      this.BangkokAddSame = data.BangkokSameAsAbove;
      this.BangkokAddNone = data.BangkokNone;
      this.Bangkok.Address = data.BangkokAddress;
      this.Bangkok.Tel = data.BangkokDirectNumber;
      this.Bangkok.Fax = data.BangkokMobile;
      //  Authorised by
      this.Represented.Name = data.AuthorisedName;
      this.Represented.Title = data.AuthorisedTitle;
      this.Represented.Tel = data.AuthorisedDirectNumber;
      this.Represented.Fax = data.AuthorisedMobile;
      this.Represented.Email = data.AuthorisedEmail;
      // Contact Person
      this.Alternate.Name = data.ContactPersonName;
      this.Alternate.Title = data.ContactPersonTitle;
      this.Alternate.Tel = data.ContactPersonDirectNumber;
      this.Alternate.Fax = data.ContactPersonMobile;
      this.Alternate.Email = data.ContactPersonEmail;
      //
      this.DescriptionServices = data.DescriptionOfServices;
      this.ExperienceMICE = data.ExperienceInMICEIndustry;
      this.OAMembership = data.MembershipOfOtherAssociation;
      console.log(this.OAMembership);
      // Category
      this.MembershipCategory = data.MembershipCategory.name.name;
      this.MembershipCategoryNumber = data.MembershipCategory.id;
      this.SubscriptionRate = data.SubscriptionRateTHB;
      this.ForHotelOnly.NumberOfRooms = data.ForHotelOnlyNumberOfRooms;
      this.ForHotelOnly.Category = data.ForHotelOnlyCategory;
      this.ForHotelOnly.TotalBaht = data.ForHotelOnlyTotalBaht;
      // Authorised Signature
      this.CapitalLetters.Name = data.CapitalLettersName;
      this.CapitalLetters.Title = data.CapitalLettersTitle;
      this.CapitalLetters.Date = data.CapitalLettersDate;
      // files
      this.AuthorisedSignatureURL = data.AuthorisedSignature.url;
      this.Documents1 =
        data.LORF2TMDocuments.Oldname + "." + data.LORF2TMDocuments.Type;
      this.Documents2 =
        data.COBRDocuments.Oldname + "." + data.COBRDocuments.Type;
      this.Documents3 =
        data.COBLDocuments.Oldname + "." + data.COBLDocuments.Type;
      this.Documents4 =
        data.COPPDocuments.Oldname + "." + data.COPPDocuments.Type;
      this.Documents5 =
        data.LORF2TM2Documents.Oldname + "." + data.LORF2TM2Documents.Type;

      this.AuthorisedSignatureCount = data.AuthorisedSignature.oldName;
      this.LORF2TMDocumentsCount = this.Documents1;
      this.COBRDocumentsCount = this.Documents2;
      if (data.COBLDocuments.Oldname == "null") {
        this.Documents3 = "";
      }
      this.COBLDocumentsCount = this.Documents3;
      this.COPPDocumentsCount = this.Documents4;
      this.LORF2TM2DocumentsCount = this.Documents5;

      // file name
      this.MultipleUploadFileURL[0] = data.LORF2TMDocuments.Newname;
      this.MultipleUploadFileURL[1] = data.COBRDocuments.Newname;
      this.MultipleUploadFileURL[2] = data.COBLDocuments.Newname;
      this.MultipleUploadFileURL[3] = data.COPPDocuments.Newname;
      this.MultipleUploadFileURL[4] = data.LORF2TM2Documents.Newname;
      // type
      this.MultipleUploadFileType[0] = data.LORF2TMDocuments.Type;
      this.MultipleUploadFileType[1] = data.COBRDocuments.Type;
      this.MultipleUploadFileType[2] = data.COBLDocuments.Type;
      this.MultipleUploadFileType[3] = data.COPPDocuments.Type;
      this.MultipleUploadFileType[4] = data.LORF2TM2Documents.Type;
      this.PreviewDocuments1 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.LORF2TMDocuments.Newname +
        "." +
        data.LORF2TMDocuments.Type;
      this.PreviewDocuments2 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.COBRDocuments.Newname +
        "." +
        data.COBRDocuments.Type;
      this.PreviewDocuments3 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.COBLDocuments.Newname +
        "." +
        data.COBLDocuments.Type;
      this.PreviewDocuments4 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.COPPDocuments.Newname +
        "." +
        data.COPPDocuments.Type;
      this.PreviewDocuments5 =
        "https://tica.or.th/uploads/membership-application/save/assets/img/" +
        data.LORF2TM2Documents.Newname +
        "." +
        data.LORF2TM2Documents.Type;
      if (this.ForHotelOnly.Category == "0") {
        this.ForHotelOnly.CategoryName = "Category A:";
        this.ForHotelOnly.Detail =
          "Hotel with meeting facilities of over 600 capacities (theatre style) THB 60 per 1 guest room";
        this.TotalBahtA = data.ForHotelOnlyTotalBaht;
        this.disabledCatA = 1;
      } else if (this.ForHotelOnly.Category == "1") {
        this.ForHotelOnly.CategoryName = "Category B:";
        this.ForHotelOnly.Detail =
          "Hotel with meeting facilities of less than 600 capacities (theatre style) THB 36 per 1 guest room";
        this.TotalBahtB = data.ForHotelOnlyTotalBaht;
        this.disabledCatB = 1;
      } else if (this.ForHotelOnly.Category == "2") {
        this.ForHotelOnly.CategoryName = "Category C:";
        this.ForHotelOnly.Detail =
          "Hotel without meeting facilities THB 12 per 1 guest room";
        this.TotalBahtC = data.ForHotelOnlyTotalBaht;
        this.disabledCatC = 1;
      } else if (this.ForHotelOnly.Category == "3") {
        this.ForHotelOnly.CategoryName = "Category D:";
        this.ForHotelOnly.Detail =
          "Up-Country Hotels with meeting facilities of over 600 capacities (Theatre style) THB 30 per 1 guest room";
        this.TotalBahtD = data.ForHotelOnlyTotalBaht;
        this.disabledCatD = 1;
      } else if (this.ForHotelOnly.Category == "4") {
        this.ForHotelOnly.CategoryName = "Category E:";
        this.ForHotelOnly.Detail =
          "Up-Country Hotels with meeting facilities of less than 600 Capacity (Theatre style) THB 18 per 1 guest room";
        this.TotalBahtE = data.ForHotelOnlyTotalBaht;
        this.disabledCatE = 1;
      } else {
        this.ForHotelOnly.CategoryName = null;
        this.ForHotelOnly.Detail = null;
      }
      this.GrandTotal =
        parseInt(this.SubscriptionRate) +
        parseInt(this.ForHotelOnly.TotalBaht) +
        this.JoiningFeeRate;
      // set disable
      if (this.MembershipCategoryNumber !== 0) {
        this.disabledHotel = 1;
      } else if (this.MembershipCategoryNumber == 0) {
        this.disabledNotHotel = 1;
      }
    },
    // multiselect
    addOptionsOther() {
      if (this.OptionsOther) {
        const tag = {
          name: this.OptionsOther,
          code:
            this.OptionsOther.substring(0, 2) +
            Math.floor(Math.random() * 10000000),
        };
        this.OAMembership.push(tag);
        this.OptionsOther = null;
        this.displayOptionsOther = true;
      }
      this.findOtherData();
    },
    findOtherData() {
      const inventory = this.options;
      const result = inventory.find(({ name }) => name === "Other");
      if (result.name !== undefined && result.name === "Other") {
        this.addOptionsOther();
      }
    },
    async BangkokAddressStatus(e) {
      if (e.target.value == 0 && e.target.checked) {
        this.BangkokDisable = true;
        this.BangkokAddNone = 0;
        this.BangkokSelectData = e.target.value;
        this.Bangkok.Address = this.Local.Address;
        this.Bangkok.Tel = this.Local.Tel;
        this.Bangkok.Fax = this.Local.Fax;
        // Disable input
        // this.BangkokDisable = true
      } else if (e.target.value == 1 && e.target.checked) {
        this.BangkokAddSame = 0;
        this.Bangkok.Address = null;
        this.Bangkok.Tel = null;
        this.Bangkok.Fax = null;
        this.BangkokSelectData = e.target.value;
        // Disable input
        this.BangkokDisable = true;
      } else if (e.target.value == 0 && !e.target.checked) {
        this.BangkokSelectData = null;
        this.Bangkok.Address = null;
        this.Bangkok.Tel = null;
        this.Bangkok.Fax = null;
        // Disable input
        this.BangkokDisable = false;
      } else if (e.target.value == 1 && !e.target.checked) {
        this.BangkokSelectData = null;
        this.Bangkok.Address = null;
        this.Bangkok.Tel = null;
        this.Bangkok.Fax = null;
        // Disable input
        this.BangkokDisable = false;
      }
    },
    setProvinceDataLocal() {
      this.LocalCity = this.Province[this.LocalSelectProvince - 1].city;
      this.LocalSelectCity = null;
    },
    spiner() {
      this.display = !this.display;
    },
    checkWordDes(data, count) {
      var len = data.split(/[\s]+/);
      if (len.length == count) {
        this.DescriptionServicesMax = this.DescriptionServices;
      } else if (len.length > count) {
        alert("You cannot put more than 30 words in this text area.");
        this.DescriptionServices = this.DescriptionServicesMax;
      }
    },
    checkWordEx(data, count) {
      var len = data.split(/[\s]+/);
      if (len.length == count) {
        this.ExperienceMICEMax = this.ExperienceMICE;
      } else if (len.length > count) {
        alert("You cannot put more than 50 words in this text area.");
        this.ExperienceMICE = this.ExperienceMICEMax;
      }
    },
    async Submit() {
      this.display = !this.display;
      if (
        this.ForHotelOnly.Category[0] == undefined &&
        this.disabledNotHotel == 1
      ) {
        alert("Please select category.");
        document.location = "/#CategoryList";
      } else {
        if (this.ForHotelOnly.Category == null) {
          this.ForHotelOnly.TotalBaht = 0;
        } else if (this.ForHotelOnly.Category == "0") {
          this.ForHotelOnly.TotalBaht = this.ForHotelOnly.NumberOfRooms * 60;
        } else if (this.ForHotelOnly.Category == "1") {
          this.ForHotelOnly.TotalBaht = this.ForHotelOnly.NumberOfRooms * 36;
        } else if (this.ForHotelOnly.Category == "2") {
          this.ForHotelOnly.TotalBaht = this.ForHotelOnly.NumberOfRooms * 12;
        } else if (this.ForHotelOnly.Category == "3") {
          this.ForHotelOnly.TotalBaht = this.ForHotelOnly.NumberOfRooms * 30;
        } else if (this.ForHotelOnly.Category == "4") {
          this.ForHotelOnly.TotalBaht = this.ForHotelOnly.NumberOfRooms * 18;
        }
        // 1. upload file and get name file to param
        await this.uploadFileSignature();
        await this.Multiupload();
        // 2. set data to session storage
        let data = {
          Organisation: this.Organisation,
          // local address
          LocalAddress: this.Local.Address,
          LocalProvince: this.LocalSelectProvince,
          LocalCity: this.LocalSelectCity,
          LocalDirectNumber: this.Local.Tel,
          LocalMobile: this.Local.Fax,
          LocalEmail: this.Email,
          LocalWebsite: this.Website,
          // Bangkok address
          BangkokSameAsAbove: this.BangkokAddSame,
          BangkokNone: this.BangkokAddNone,
          BangkokAddress: this.Bangkok.Address,
          BangkokDirectNumber: this.Bangkok.Tel,
          BangkokMobile: this.Bangkok.Fax,
          //  Authorised by
          AuthorisedName: this.Represented.Name,
          AuthorisedTitle: this.Represented.Title,
          AuthorisedDirectNumber: this.Represented.Tel,
          AuthorisedMobile: this.Represented.Fax,
          AuthorisedEmail: this.Represented.Email,
          // Contact Person
          ContactPersonName: this.Alternate.Name,
          ContactPersonTitle: this.Alternate.Title,
          ContactPersonDirectNumber: this.Alternate.Tel,
          ContactPersonMobile: this.Alternate.Fax,
          ContactPersonEmail: this.Alternate.Email,
          //
          DescriptionOfServices: this.DescriptionServices,
          ExperienceInMICEIndustry: this.ExperienceMICE,
          MembershipOfOtherAssociation: this.OAMembership,
          // files
          LORF2TMDocuments: {
            Newname: this.MultipleUploadFileURL[0],
            Oldname: this.Documents1.split(".").slice(0, -1).join("."),
            Type: this.MultipleUploadFileType[0],
          },
          COBRDocuments: {
            Newname: this.MultipleUploadFileURL[1],
            Oldname: this.Documents2.split(".").slice(0, -1).join("."),
            Type: this.MultipleUploadFileType[1],
          },
          COBLDocuments: {
            Newname: this.MultipleUploadFileURL[2],
            Oldname: this.Documents3.split(".").slice(0, -1).join("."),
            Type: this.MultipleUploadFileType[2],
          },
          COPPDocuments: {
            Newname: this.MultipleUploadFileURL[3],
            Oldname: this.Documents4.split(".").slice(0, -1).join("."),
            Type: this.MultipleUploadFileType[3],
          },
          LORF2TM2Documents: {
            Newname: this.MultipleUploadFileURL[4],
            Oldname: this.Documents5.split(".").slice(0, -1).join("."),
            Type: this.MultipleUploadFileType[4],
          },
          // ****************************************************************************************************
          AuthorisedSignature: {
            url: this.AuthorisedSignatureURL,
            oldName: this.AuthorisedSignatureCount,
          },
          // ****************************************************************************************************
          // Category
          MembershipCategory: {
            id: this.MembershipCategoryNumber,
            name: this.MembershipCategoryData[this.MembershipCategoryNumber],
          },
          SubscriptionRateTHB: this.SubscriptionRate,
          ForHotelOnlyNumberOfRooms:
            this.ForHotelOnly.NumberOfRooms == null
              ? 0
              : this.ForHotelOnly.NumberOfRooms,
          ForHotelOnlyCategory: this.ForHotelOnly.Category,
          ForHotelOnlyTotalBaht:
            this.ForHotelOnly.TotalBaht == null
              ? 0
              : this.ForHotelOnly.TotalBaht,
          // Authorised Signature
          CapitalLettersName: this.CapitalLetters.Name,
          CapitalLettersTitle: this.CapitalLetters.Title,
          CapitalLettersDate: this.CapitalLetters.Date,
        };
        console.log(data.AuthorisedSignature);
        sessionStorage.setItem("membershipApplication", JSON.stringify(data));
        console.log(
          JSON.parse(sessionStorage.getItem("membershipApplication"))
        );
        // 3. go to preview page
        this.$router.push("/preview");
      }
    },
    hotelChange() {
      if (
        this.ForHotelOnly.NumberOfRooms == null ||
        this.ForHotelOnly.NumberOfRooms != null
      ) {
        this.disabledHotel = 0;
        this.disabledNotHotel = 1;
      }

      if (
        this.ForHotelOnly.NumberOfRooms == "" &&
        this.ForHotelOnly.Category == ""
      ) {
        this.disabledHotel = 0;
        this.disabledNotHotel = 0;
      }
    },
    notHotelChange() {
      if (this.MembershipCategoryNumber == 0) {
        this.disabledHotel = 0;
      } else if (this.MembershipCategoryNumber != 0) {
        this.disabledHotel = 1;
      }
      this.disabledNotHotel = 0;
      this.SubscriptionRate =
        this.MembershipCategoryData[this.MembershipCategoryNumber].price;
      this.MembershipCategory =
        this.MembershipCategoryData[this.MembershipCategoryNumber].name;
    },
    setFileSignature(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files[0]["type"] == "image/jpeg" || files[0]["type"] == "image/png") {
        this.AuthorisedSignature = files[0];
        this.AuthorisedSignatureCount = files[0].name;
      } else {
        alert("Please Select image file (jpr, jprg, png)");
        this.AuthorisedSignatureCount = null;
      }
    },
    previewFiles(event) {
      if (event.target.files.length !== 3) {
        this.$refs.fileInput.value = null;
        alert("Please select 3 Files");
        this.RequiredDocumentsCount = null;
      } else {
        this.MultipleUploadFile = event.target.files;
        this.RequiredDocumentsCount =
          event.target.files.length + " documents file.";
      }
    },
    uploadLORF2TM(event) {
      if (event.target.files.length == 0 || event.target.files.length > 1) {
        this.LORF2TMDocumentsCount = this.LORF2TMDocuments[0].name;
      } else if (event.target.files.length == 1) {
        this.LORF2TMDocuments = event.target.files;
        this.LORF2TMDocumentsCount = this.LORF2TMDocuments[0].name;
      }
    },
    uploadCOBR(event) {
      if (event.target.files.length == 0 || event.target.files.length > 1) {
        this.COBRDocumentsCount = this.COBRDocuments[0].name;
      } else if (event.target.files.length == 1) {
        this.COBRDocuments = event.target.files;
        this.COBRDocumentsCount = this.COBRDocuments[0].name;
      }
    },
    uploadCOBL(event) {
      if (event.target.files.length == 0 || event.target.files.length > 1) {
        this.COBLDocumentsCount = this.COBLDocuments[0].name;
      } else if (event.target.files.length == 1) {
        this.COBLDocuments = event.target.files;
        this.COBLDocumentsCount = this.COBLDocuments[0].name;
      }
    },
    uploadCOPP(event) {
      if (event.target.files.length == 0 || event.target.files.length > 1) {
        this.COPPDocumentsCount = this.COPPDocuments[0].name;
      } else if (event.target.files.length == 1) {
        this.COPPDocuments = event.target.files;
        this.COPPDocumentsCount = this.COPPDocuments[0].name;
      }
    },
    uploadLORF2TM2(event) {
      if (event.target.files.length == 0 || event.target.files.length > 1) {
        this.LORF2TM2DocumentsCount = this.LORF2TM2Documents[0].name;
      } else if (event.target.files.length == 1) {
        this.LORF2TM2Documents = event.target.files;
        this.LORF2TM2DocumentsCount = this.LORF2TM2Documents[0].name;
      }
    },
    async uploadFileSignature() {
      if (this.AuthorisedSignature !== null) {
        // Upload Signature
        var AuthSignatureURL = null;
        const data = new FormData();
        data.append("AuthorisedSignature", this.AuthorisedSignature);
        const url =
          "https://www.tica.or.th/uploads/membership-application/save/uploadAuthSignature.php";
        const header = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        await axios.post(url, data, header).then(function (response) {
          if (response.data.status == "success") {
            AuthSignatureURL = response.data.response;
          } else {
            window.location.href = "https://www.tica.or.th/404";
          }
        });
        this.AuthorisedSignatureURL = AuthSignatureURL;
        this.AuthorisedSignatureCount = this.AuthorisedSignature.name;
      }
    },
    //
    async uploadFileMultiple(Filedata, id) {
      var fileMultiple = null;
      var fileTypeMultiple = null;
      const data = new FormData();
      data.append("fileUpload", Filedata);
      const url =
        "https://www.tica.or.th/uploads/membership-application/save/uploadFile.php";
      const header = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      await axios.post(url, data, header).then(function (response) {
        if (response.data.status == "success") {
          fileMultiple = response.data.response;
          fileTypeMultiple = response.data.type;
        } else {
          window.location.href = "https://www.tica.or.th/404";
        }
      });
      this.MultipleUploadFileURL[id] = fileMultiple;
      this.MultipleUploadFileType[id] = fileTypeMultiple;
    },
    //
    async Multiupload() {
      if (this.LORF2TMDocuments !== null) {
        await this.uploadFileMultiple(this.LORF2TMDocuments[0], 0);
        this.Documents1 = this.LORF2TMDocuments[0].name;
      }
      if (this.COBRDocuments !== null) {
        await this.uploadFileMultiple(this.COBRDocuments[0], 1);
        this.Documents2 = this.COBRDocuments[0].name;
      }
      if (this.COBLDocuments !== null) {
        await this.uploadFileMultiple(this.COBLDocuments[0], 2);
        this.Documents3 = this.COBLDocuments[0].name;
      }
      if (this.COPPDocuments !== null) {
        await this.uploadFileMultiple(this.COPPDocuments[0], 3);
        this.Documents4 = this.COPPDocuments[0].name;
      }
      if (this.LORF2TM2Documents !== null) {
        await this.uploadFileMultiple(this.LORF2TM2Documents[0], 0);
        this.Documents5 = this.LORF2TM2Documents[0].name;
      }
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}
.bg_dark_blue {
  background-color: #102f50 !important;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.home {
  background-color: #3c3c3b !important;
  font-family: Georgia, Times, serif !important;
}
input[type="file"] {
  display: none !important;
}
.custom-file-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 3px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}
.text-truncate {
  white-space: nowrap !important;
  padding-right: 5rem !important;
  padding-left: 1rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.w-45 {
  width: 45%;
}
.other-btn {
  padding: 6px 25px !important;
}
</style>
<style>
.multiselect__option--highlight {
  background: #102f51 !important;
  outline: none !important;
  color: #fff !important;
}
.multiselect__option--highlight:after {
  background: #102f51 !important;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #102f51;
  margin-bottom: 0;
}
.multiselect__tags {
  min-height: 25px;
  padding: 2px 40px 0 8px;
  border-color: black;
}
.multiselect__tag-icon:after {
  color: white;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #102f51 !important;
}
</style>